import { SearchParamValues, useSearchParamState } from './useSearchParamState';
import { ChangeEvent } from 'react';

interface RegisterOption {
  onChange?: (event: ChangeEvent<{ value: string }>) => void;
}

export function useFilterForm<TResult extends Record<string, unknown>>(parser: (data: unknown) => TResult) {
  const { values, setValues: setSearchParamValues } = useSearchParamState<TResult>(parser);

  function setValues(next: SearchParamValues<TResult>) {
    if ('pageIndex' in values && !('pageIndex' in next)) {
      setSearchParamValues({ ...next, pageIndex: '1' });
      return;
    }

    setSearchParamValues(next);
  }

  function setValue(key: keyof TResult, value: string | undefined) {
    const next = {} as SearchParamValues<TResult>;
    next[key] = value;

    setValues(next);
  }

  function register(key: keyof TResult, options?: RegisterOption) {
    return {
      onChange: (event: ChangeEvent<{ value: string }>) => {
        setValue(key, event.target.value);

        if (options?.onChange) {
          options.onChange(event);
        }
      },
      defaultValue: values[key],
    };
  }

  return {
    register,
    setValues,
    setValue,
    values,
  };
}
